export default {
  aboutapp: {
    subtitle: "About Us",

    title: "Welcome To Organic Agriculture Grocery Shop",

    desc:
      "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form.",

    item1: "Organic products who are so",
    item2: "Healthy food everyday",
    item3: "Local growth of fresh food",
    item4: "Demoralized charms of pleasure",

    cta: "Start Using Mahal Today",

    quote:
      "“There are many variations of passages of Lorem Ipsum available, but the majority they suffered”",

    author: "Robart Day",
  },
};